var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shop-item"},[_c('ItemImage',{attrs:{"itemId":_vm.itemId}}),_c('DetailView',{attrs:{"product":_vm.product}}),_c('ContactBlock')],1)}
var staticRenderFns = []

export { render, staticRenderFns }